var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",staticClass:"app-heading",attrs:{"data-jest":"app-heading"}},_vm.$listeners),[_vm._t("default"),_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_vm._t("after-text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }